import React from 'react';

/**
 * Renderiza el bloque DashboardRanking de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function DashboardRanking({
  v
}) {
  return React.createElement("section", {
    style: {
      "background": "linear-gradient(180deg,rgba(22,40,64,0.55) 0%,rgba(12,24,42,0.55) 100%)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.925926vh",
      "boxShadow": "0 0.092593vh 0 rgba(255,255,255,0.03) inset,0 0.740741vh 2.222222vh rgba(0,0,0,0.25)",
      "backdropFilter": "blur(0.555556vh)",
      "padding": "1.111111vh 1.481481vh",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.740741vh",
      "flex": v.sfrFlex,
      "width": v.sfrW,
      "height": v.sfrH,
      "minHeight": "0"
    }
  }, v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "space-between",
      "alignItems": "baseline",
      "gap": "0.740741vh"
    }
  }, v.text("\n          "), React.createElement("h2", {
    style: {
      "margin": "0",
      "fontSize": "1.481481vh",
      "fontWeight": "600",
      "whiteSpace": "nowrap"
    }
  }, v.text("SFR corregido")), v.text("\n          "), React.createElement("span", {
    style: {
      "fontSize": "1.018519vh",
      "color": "#8793a6",
      "whiteSpace": "nowrap"
    }
  }, v.text(v.fSub)), v.text("\n        ")), v.text("\n        "), v.fSingle ? React.createElement(React.Fragment, null, v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "baseline",
      "gap": "0.925926vh"
    }
  }, v.text("\n          "), React.createElement("span", {
    style: {
      "font": "600 2.592593vh 'IBM Plex Mono',monospace",
      "color": v.fBigC
    }
  }, v.text(v.fBig)), v.text("\n          "), React.createElement("span", {
    style: {
      "fontSize": "1.111111vh",
      "color": "#b8c1ce"
    }
  }, v.text(v.fBigLab)), v.text("\n          "), React.createElement("span", {
    style: {
      "marginLeft": "auto",
      "font": "500 1.111111vh 'IBM Plex Mono',monospace",
      "color": v.fDevC
    }
  }, v.text(v.fDev)), v.text("\n        ")), v.text("\n        ")) : null, v.text("\n        "), v.fMulti ? React.createElement(React.Fragment, null, v.text("\n          "), React.createElement("div", {
    style: {
      "display": "flex",
      "flexWrap": "wrap",
      "gap": "0.37037vh 1.111111vh",
      "maxHeight": "3.518519vh",
      "overflowY": "auto",
      "scrollbarWidth": "thin",
      "flex": "none"
    }
  }, v.text("\n            "), (v.fVals || []).map((_v, index71) => React.createElement(React.Fragment, {
    key: index71
  }, v.text("\n              "), React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.555556vh",
      "fontSize": "1.111111vh",
      "whiteSpace": "nowrap"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.46875vw",
      "height": "0.833333vh",
      "borderRadius": "0.185185vh",
      "background": _v.c
    }
  }, null), React.createElement("span", {
    style: {
      "color": "#b8c1ce"
    }
  }, v.text(_v.name)), React.createElement("span", {
    style: {
      "fontFamily": "'IBM Plex Mono',monospace",
      "fontWeight": "600",
      "color": _v.vc
    }
  }, v.text(_v.val))), v.text("\n            "))), v.text("\n          ")), v.text("\n        ")) : null, v.text("\n        "), React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": "3.333333vw minmax(0,1fr) 4.375vw",
      "gap": "0.555556vh",
      "flex": "1",
      "minHeight": "13.888889vh"
    }
  }, v.text("\n          "), React.createElement("div", {
    "aria-label": "Eje Y de SFR en porcentaje",
    style: {
      "position": "relative"
    }
  }, React.createElement("span", {
    style: {
      "position": "absolute",
      "left": "0",
      "top": "50%",
      "writingMode": "vertical-rl",
      "transform": "translateY(-50%) rotate(180deg)",
      "whiteSpace": "nowrap",
      "fontSize": "1.018519vh",
      "fontWeight": "600",
      "color": "#e64d0e"
    }
  }, v.text("SFR (%)")), (v.fYTicks || []).map((t, index72) => React.createElement(React.Fragment, {
    key: index72
  }, React.createElement("span", {
    style: {
      "position": "absolute",
      "right": "0",
      "bottom": t.pos,
      "transform": "translateY(50%)",
      "font": "1.018519vh 'IBM Plex Mono',monospace",
      "color": "#e64d0e"
    }
  }, v.text(t.lab))))), v.text("\n          "), React.createElement("div", {
    "onMouseMove": v.sMoveZ,
    "onMouseLeave": v.sLeaveZ,
    "onMouseDown": v.sDownZ,
    "onMouseUp": v.sUpZ,
    "onWheel": v.sWheelZ,
    "data-wheel-zoom": "1",
    "onClick": v.sClickZ,
    style: {
      "position": "relative",
      "borderBottom": "0.092593vh solid #2a3446",
      "borderLeft": "0.092593vh solid #e64d0e",
      "borderRight": "0.092593vh solid #41a3cf",
      "cursor": v.sCursor
    }
  }, v.text("\n            "), React.createElement("div", {
    style: {
      "position": "absolute",
      "left": "0",
      "right": "0",
      "bottom": v.fBandB,
      "height": v.fBandH,
      "background": "rgba(135,147,166,0.10)",
      "pointerEvents": "none"
    }
  }, null), v.text("\n            "), (v.fYTicks || []).map((t, index73) => React.createElement(React.Fragment, {
    key: index73
  }, React.createElement("div", {
    style: {
      "position": "absolute",
      "left": "0",
      "right": "0",
      "bottom": t.pos,
      "borderTop": "0.092593vh solid rgba(46,179,238,0.07)"
    }
  }, null))), v.text("\n            "), React.createElement("svg", {
    "viewBox": v.fVB,
    "preserveAspectRatio": "none",
    style: {
      "position": "absolute",
      "inset": "0",
      "width": "100%",
      "height": "100%",
      "display": "block",
      "overflow": "visible"
    }
  }, v.text("\n              "), (v.fBars || []).map((b, index74) => React.createElement(React.Fragment, {
    key: index74
  }, React.createElement("path", {
    "d": b.d,
    "fill": b.c
  }, null))), v.text("\n              ")), v.text("\n            "), (v.fFoodBars || []).map((bar, index) => React.createElement("div", {
    key: index,
    "data-food-bar": "1",
    style: {
      "position": "absolute",
      "left": bar.left,
      "bottom": "0",
      "width": bar.width,
      "height": bar.height,
      "borderRadius": "0.277778vh 0.277778vh 0 0",
      "backgroundColor": bar.c,
      "backgroundImage": "repeating-linear-gradient(135deg,transparent,transparent 0.277778vh,rgba(4,10,20,0.85) 0.277778vh,rgba(4,10,20,0.85) 0.462963vh)",
      "pointerEvents": "none"
    }
  })), v.text("\n            "), React.createElement("div", {
    style: {
      "position": "absolute",
      "left": "0",
      "right": "0",
      "bottom": v.fRefPos,
      "height": "0",
      "borderTop": "0.231481vh dashed #E8500F",
      "filter": "drop-shadow(0 0 0.277778vh rgba(232,80,15,0.7))",
      "pointerEvents": "none",
      "zIndex": "2"
    }
  }, null), v.text("\n            "), React.createElement("div", {
    style: {
      "position": "absolute",
      "left": "0.3125vw",
      "bottom": v.fRefPos,
      "transform": "translateY(-0.277778vh)",
      "font": "600 1.018519vh 'IBM Plex Mono',monospace",
      "color": "#E8500F",
      "background": "rgba(4,10,20,0.85)",
      "padding": "0 0.37037vh",
      "borderRadius": "0.277778vh",
      "pointerEvents": "none",
      "zIndex": "2"
    }
  }, v.text("100 %")), v.text("\n            "), React.createElement("div", {
    style: {
      "position": "absolute",
      "top": "0",
      "bottom": "0",
      "left": v.fX,
      "width": "0.052083vw",
      "background": "#e4e9f0",
      "opacity": "0.6",
      "pointerEvents": "none",
      "display": v.fTipDisp
    }
  }, null), v.text("\n            "), React.createElement("div", {
    "onMouseMove": v.tipStop,
    "onMouseDown": v.tipStop,
    "onClick": v.tipStop,
    "onWheel": v.tipStop,
    "data-tip-scroll": "1",
    style: {
      "position": "absolute",
      "top": "0.555556vh",
      "left": v.fX,
      "transform": v.fTipTx,
      "minWidth": "8.854167vw",
      "background": "rgba(4,10,20,0.96)",
      "border": "0.092593vh solid rgba(46,179,238,0.2)",
      "borderRadius": "0.740741vh",
      "padding": "0.740741vh 0.925926vh",
      "display": v.fTipFlex,
      "flexDirection": "column",
      "gap": "0.277778vh",
      "pointerEvents": "auto",
      "cursor": "default",
      "maxHeight": "max(14.814815vh, calc(100% - 1.111111vh))",
      "overflowX": "auto",
      "overflowY": "auto",
      "overscrollBehavior": "contain",
      "scrollbarWidth": "thin",
      "zIndex": "4"
    }
  }, v.text("\n              "), React.createElement("div", {
    style: {
      "position": "sticky",
      "top": "-0.740741vh",
      "background": "rgba(4,10,20,0.98)",
      "padding": "0.185185vh 0 0.37037vh",
      "marginTop": "-0.185185vh",
      "zIndex": "1",
      "font": "500 1.111111vh 'IBM Plex Mono',monospace"
    }
  }, v.text(v.fTipDate)), v.text("\n              "), React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": "minmax(5.208333vw,1fr) auto auto",
      "columnGap": "1.111111vh",
      "rowGap": "0.277778vh",
      "fontSize": "1.111111vh",
      "color": "#8793a6"
    }
  }, React.createElement("span", {}, null), React.createElement("span", {}, v.text("SFR")), React.createElement("span", {}, v.text("Alimento")), (v.fTipRows || []).map((r, index76) => React.createElement(React.Fragment, {
    key: index76
  }, React.createElement("div", {
    style: {
      "display": "contents"
    }
  }, React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.555556vh",
      "color": "#b8c1ce"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.46875vw",
      "height": "0.833333vh",
      "borderRadius": "0.185185vh",
      "background": r.c
    }
  }, null), v.text(r.name)), React.createElement("span", {
    style: {
      "fontFamily": "'IBM Plex Mono',monospace",
      "color": "#e4e9f0"
    }
  }, v.text(r.val)), React.createElement("span", {
    style: {
      "fontFamily": "'IBM Plex Mono',monospace",
      "color": "#e4e9f0",
      "textAlign": "right"
    }
  }, v.text(r.food)))))), v.text("\n            ")), v.text("\n          ")), v.text("\n          "), React.createElement("div", {
    "aria-label": "Eje Y de alimento entregado en toneladas",
    style: {
      "position": "relative"
    }
  }, React.createElement("span", {
    style: {
      "position": "absolute",
      "right": "0",
      "top": "50%",
      "writingMode": "vertical-rl",
      "transform": "translateY(-50%)",
      "whiteSpace": "nowrap",
      "fontSize": "1.018519vh",
      "fontWeight": "600",
      "color": "#41a3cf"
    }
  }, v.text("Alimento entregado (ton)")), (v.fFoodYTicks || []).map((t, index77) => React.createElement(React.Fragment, {
    key: index77
  }, React.createElement("span", {
    style: {
      "position": "absolute",
      "left": "0",
      "bottom": t.pos,
      "transform": "translateY(50%)",
      "font": "1.018519vh 'IBM Plex Mono',monospace",
      "fontWeight": "500",
      "color": "#41a3cf",
      "whiteSpace": "nowrap"
    }
  }, v.text(t.lab))))), v.text("\n        ")), v.text("\n        "), React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": "3.333333vw minmax(0,1fr) 4.375vw",
      "gap": "0.555556vh",
      "font": "1.018519vh 'IBM Plex Mono',monospace",
      "color": "#5a667a"
    }
  }, v.text("\n          "), React.createElement("div", {}, null), React.createElement("div", {
    style: {
      "position": "relative",
      "height": "1.296296vh"
    }
  }, (v.fXTicks || []).map((t, index78) => React.createElement(React.Fragment, {
    key: index78
  }, React.createElement("span", {
    style: {
      "position": "absolute",
      "left": t.pos,
      "transform": "translateX(-50%)",
      "whiteSpace": "nowrap"
    }
  }, v.text(t.lab))))), React.createElement("div", {}, null), v.text("\n        ")), v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "gap": "1.111111vh",
      "flexWrap": "nowrap",
      "overflowX": "auto",
      "overflowY": "hidden",
      "scrollbarWidth": "thin",
      "flex": "none",
      "alignItems": "center",
      "fontSize": "1.018519vh",
      "color": "#8793a6"
    }
  }, v.text("\n          "), (v.fLeg || []).map((l, index79) => React.createElement(React.Fragment, {
    key: index79
  }, React.createElement("span", {
    style: {
      "flex": "none",
      "display": "flex",
      "alignItems": "center",
      "gap": "0.462963vh",
      "color": "#e4e9f0"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.520833vw",
      "height": "0.925926vh",
      "borderRadius": "0.185185vh",
      "background": l.c
    }
  }, null), v.text(l.name)))), v.text("\n          "), React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.462963vh",
      "flex": "none"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.520833vw",
      "height": "0.925926vh",
      "borderRadius": "0.185185vh",
      "background": "#8793a6"
    }
  }, null), v.text("SFR (%)")), React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.462963vh",
      "flex": "none"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.520833vw",
      "height": "0.925926vh",
      "borderRadius": "0.185185vh",
      "backgroundColor": "#8793a6",
      "backgroundImage": "repeating-linear-gradient(135deg,transparent,transparent 0.277778vh,rgba(4,10,20,0.85) 0.277778vh,rgba(4,10,20,0.85) 0.462963vh)"
    }
  }, null), v.text("Alimento entregado (ton)")), v.text("\n          "), React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.462963vh"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.729167vw",
      "borderTop": "0.185185vh dashed #E8500F"
    }
  }, null), v.text("100 %")), v.text("\n          "), React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.462963vh"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.625vw",
      "height": "0.740741vh",
      "background": "rgba(135,147,166,0.25)"
    }
  }, null), v.text("Objetivo ±" + v.fTol + " %")), v.text("\n        ")), v.text("\n      "));
}
